/**
 * Сервис для бэкапа и восстановления состояния фильтров
 * @class FilterBackup
 */

import * as _ from 'lodash';

export default angular.module('cian.newbuild.filter.filterBackup', [])
  .factory('FilterBackup', ['FilterService', FilterService => {
    const service = {};

    /**
     * @type {{filter, regions}}
     */
    let backup = {};

    /**
     * @memberOf FilterBackup
     */
    service.backup = () => {
      backup = {
        filter: angular.copy(FilterService.filter),
        regions: angular.copy(FilterService.selectedRegions),
      };
    };

    /**
     * @memberOf FilterBackup
     */
    service.restore = () => {
      if (!_.isEqual(FilterService.filter, backup.filter)) {
        FilterService.filter = backup.filter;
      }

      if (!_.isEqual(FilterService.selectedRegions, backup.regions)) {
        FilterService.selectedRegions = backup.regions;
      }
    };

    return service;
  }])
  .name;



// WEBPACK FOOTER //
// ./src/serp/services/filter-backup.service.js